<app-truecaller-popup *ngIf="!userdata && isMobile && !isIos" [execute]="eventsSubject.asObservable()"></app-truecaller-popup>
<div class="wrapper">
  <div class="banner-image">
    <img *ngIf="!isMobile" loading="lazy" data-src="/assets/images/sip/sip-bg.png" alt="sip" />
    <img *ngIf="isMobile" loading="lazy" data-src="/assets/images/sip/sip-bg-mobile.png" alt="sip" />
  </div>
  <div class="content-wrapper">
    <div class="content">
      <div class="header">
        <div class="title">Save a Life, Every Month</div>
        <div class="text">
          <div>Create a larger impact with</div>
          <div>Ketto’s Monthly Giving!</div>
        </div>
      </div>
      <ngx-glide [showArrows]="false" [autoplay]="2500" [perView]="1" [gap]="20" [animationDuration]="1000">
        <div class="nudge" *ngFor="let item of nudgeText; let i = index">
          <img loading="lazy" data-src="/assets/images/sip-by-ketto.png" alt="sip" />
          <div class="nudge-content">
            <div class="head" [innerHtml]="'With ' + paymentV2.getMinSipAmount(currency)?.currency_symbol + (paymentV2.getMinSipAmount(currency)?.amount * (i + 1)) + '/mo'"></div>
            <div class="text">{{ item?.text }}</div>
          </div>
        </div>
      </ngx-glide>
      <div inViewport (inViewportAction)="viewport($event)" id="donation-form" class="button">
        <button (click)="openDialog(paymentTemplate)" class="btn">
          <div class="btn-text">Become a Monthly Donor</div>
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #paymentTemplate>
  <div *ngIf="currency" class="payment-card" (click)="bannerClickList()">
    <div class="payment-left-container">
      <img class="payment-img" data-src="assets/images/hand_img.png" alt="sip" />
      <div class="payment-left-header">
        Create a larger impact with Ketto’s Monthly Giving!
      </div>
      <div class="extra-info">
        <div *ngFor="let info of infoText" class="info">
          <span class="material-icons">check</span><span [innerHtml]="info?.text"></span>
        </div>
      </div>
    </div>
    <div class="payment-form">
      <div class="close">
        <button class="payment-sip-dialog-back-btn" (click)="close()" mat-button>
          <i class="material-icons">close</i>
        </button>
      </div>
      <div>
        <app-payment-sip [config]="{
            themeColor: '#01BFBD',
            slabTheme: 'slab-theme-v3',
            slabsPostLabel: 'per month',
            formTheme: 'form-theme-v3',
            dialogBtnTheme: 'payment-btn-v1',
            currency: currency,
            origin: 'rfd',
            showTutorial: false,
            showOptionBackBtn: true,
            disableCard: true,
            showSlabRecommended: true
          }">
        </app-payment-sip>
      </div>
    </div>
  </div>
</ng-template>